import React, { useState, useEffect }  from 'react';
import { useSelector } from 'react-redux';
import { PlanType } from '../../components/enums/plan-type';
import CompareField from './compare-field';
import { getYearlyFsaAmount } from '../../components/fsa-calculator';

const FsaTypeReview = ({title, planType, modifiedSelections, unmodifiedSelections, setIsModified, fsaDetails}) => {
    const [modified, setModified] = useState();
    const [unmodified, setUnmodified] = useState();
    const enrollments = useSelector(s => s.enrollments);
    const [weeklyAmount, setWeeklyAmount] = useState();
    const [unmodifiedMonthlyAmount, setUnmodifiedMonthlyAmount] = useState();
    const [yearlyAmount, setYearlyAmount] = useState();
    const [unmodifiedYearlyAmount, setUnmodifiedYearlyAmount] = useState();
    const [remainingPayChecksThisYear, setRemainingPayChecksThisYear] = useState();

    useEffect(() => {
        const m =modifiedSelections?.find(s => s.planType === planType);
        const u = unmodifiedSelections?.find(s => s.planType === planType);
        setModified(m);
        setUnmodified(u);
        setWeeklyAmount(m?.amount);
        setUnmodifiedMonthlyAmount(u?.amount);
        if((m?.amount ?? null) !== (u?.amount ?? null))
            setIsModified(true);
    }, [enrollments, modifiedSelections, unmodifiedSelections]);

    useEffect(() => {
        if(!fsaDetails)
            return;
        console.log("FSA Details", fsaDetails);
        const yearlyMax = planType === PlanType.MedicalCareFsa ? fsaDetails.medicalCare.yearlyMax : fsaDetails.dependentCare.yearlyMax;
        let ytdAmount = planType === PlanType.MedicalCareFsa ? fsaDetails.medicalCare.yearToDateContributionAmount : fsaDetails.dependentCare.yearToDateContributionAmount;
        ytdAmount = isNaN(ytdAmount) ? 0 : ytdAmount;
        const remainingPayChecksThisYear = fsaDetails.remainingPayChecksThisYear;
        setRemainingPayChecksThisYear(remainingPayChecksThisYear);
        if(isNaN(weeklyAmount)) {
            setYearlyAmount(null);
        } else {
            setYearlyAmount(setYearly(modified?.amount, yearlyMax, remainingPayChecksThisYear, ytdAmount, fsaDetails.payPeriodsUntilEffectiveDate));
        }
        if(isNaN(unmodifiedMonthlyAmount)){
            setUnmodifiedYearlyAmount(null)
        } else {
            setUnmodifiedYearlyAmount(setYearly(unmodified?.amount, yearlyMax, remainingPayChecksThisYear, ytdAmount, fsaDetails.payPeriodsUntilEffectiveDate))
        }
        

    }, [fsaDetails]);

    const rounder = (num) => {
        var mult = parseInt("1" + "0".repeat(2));
        num = num * mult;
        return Number(num / mult).toFixed(2);
   };

   const setYearly = (weeklyAmount, yearlyMax, remainingPayChecksThisYear, ytdAmount, payPeriodsUntilEffectiveDate) => {
    let amount = getYearlyFsaAmount(weeklyAmount, remainingPayChecksThisYear, ytdAmount, unmodifiedMonthlyAmount, payPeriodsUntilEffectiveDate, yearlyMax)
    amount = rounder(amount);
    amount = amount > yearlyMax ? yearlyMax : amount;
    return amount;
    }

    return ( 
        <div className='mt-4'>
        <div className='grid grid-cols-3 items-center max-w-xl'>
        {yearlyAmount > 0 ?
            <>
            <CompareField title={`${title}  Weekly Amount`} modifiedValue={weeklyAmount} unmodifiedValue={unmodified?.amount} type="currency" /> 
            <span className='pt-3 text-slate-400 text-xs'>X {remainingPayChecksThisYear} weeks</span>
            <CompareField title="Yearly Amount" modifiedValue={yearlyAmount} unmodifiedValue={unmodifiedYearlyAmount} type="currency" />
            </> :
            <>
            <CompareField title={title} modifiedValue="Waived" unmodifiedValue={unmodified?.amount ?? "Waived"} />
            </>
         }
        </div>
        </div>
     );
}
 
export default FsaTypeReview;